const magnifiedImages = new WeakSet();

function resetMagnifiedImage(image) {
  image.style.removeProperty('transform');
  image.style.removeProperty('transform-origin');
  image.style.removeProperty('will-change');
}

function magnifyWithPointer(image, event, zoomRatio) {
  const bounds = image.parentElement.getBoundingClientRect();
  if (!bounds.width || !bounds.height) return;

  const x = Math.min(Math.max(event.clientX - bounds.left, 0), bounds.width);
  const y = Math.min(Math.max(event.clientY - bounds.top, 0), bounds.height);
  image.style.transformOrigin = `${(x / bounds.width) * 100}% ${(y / bounds.height) * 100}%`;
  image.style.transform = `scale(${zoomRatio})`;
}

function enableZoomOnHover(zoomRatio = 2) {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (magnifiedImages.has(image)) return;
    magnifiedImages.add(image);

    image.addEventListener('pointerenter', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      image.style.willChange = 'transform';
      magnifyWithPointer(image, event, zoomRatio);
    });

    image.addEventListener('pointermove', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      magnifyWithPointer(image, event, zoomRatio);
    });

    image.addEventListener('pointerleave', () => resetMagnifiedImage(image));
    image.addEventListener('pointercancel', () => resetMagnifiedImage(image));
  });
}

enableZoomOnHover(2);
